import { Elements, useStripe } from "@stripe/react-stripe-js";
import { Flex, toast, ViewerContext } from "dash-ui";
import { PaymentElementForm } from "../PaymentElementForm";
import { RefObject, useContext, useEffect, useRef, useState } from "react";

interface IStripePaymentFormProps {
  formRef: RefObject<HTMLFormElement>;
  onSubmit: (paymentMethodId: string) => void;
  setInvalidForm: (status: boolean) => void;
}

function StripePaymentForm({
  formRef,
  onSubmit,
  setInvalidForm,
}: IStripePaymentFormProps) {
  const { account } = useContext(ViewerContext);

  const stripe = useStripe();

  const [clientSecret, setClientSecret] = useState("");

  // Fetch the Stripe client secret for a SetupIntent
  useEffect(() => {
    async function getSecret() {
      if (!account?.stripeCustomerId) return;

      try {
        const res = await fetch(
          `${process.env["REACT_APP_REST"]}/stripe/secret/${account?.stripeCustomerId}`
        );
        const data = await res.json();
        setClientSecret(data.client_secret);
      } catch (error) {
        toast.error("Failed to fetch client secret.");
      }
    }

    getSecret();
  }, [account, setClientSecret]);

  if (!clientSecret) return null;

  return (
    <Flex flexDirection="column" w="100%" className="text-slate-400">
      <Flex w="100%">
        <Elements
          stripe={stripe}
          options={{
            clientSecret,
            appearance: {
              labels: "floating",
            },
          }}>
          <PaymentElementForm
            formRef={formRef}
            setInvalidForm={setInvalidForm}
            onSubmit={onSubmit}
          />
        </Elements>
      </Flex>
    </Flex>
  );
}

export default StripePaymentForm;
